<div class="zing-ui">
  <div class="modal-header">
    <h4 class="modal-title">{{ title | translate }}</h4>
      <i class="mdi mdi-close font-20 cursor-pointer float-end" (click)="close.emit(false)"></i>
  </div>
  <div class="modal-body">
    <p>{{ body | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-info w-auto" (click)="close.emit(false)">
      {{ 'Cancel' | translate }}
    </button>
    <button id="confirm-button" type="button" class="btn btn-info w-auto" (click)="close.emit(true)">
      {{ 'Confirm' | translate }}
    </button>
  </div>
</div>
